import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function LocalBeverages() {
  const [selectedBeverages, setSelectedBeverages] = useState<string[]>([]);
  const navigate = useNavigate();

  const beverages = [
    'Akpeteshie (Local Gin)',
    'Palm Wine (Fresh)',
    'Pito (Millet Beer)',
    'Sobolo (Hibiscus Drink)',
    'Asana (Fermented Corn Drink)',
    'Brukina (Millet Drink)',
    'Lamugine (Ginger Drink)',
    'Nmedaa (Palm Wine Liquor)',
    'Burkina (Traditional Beer)',
    'Nsafufuo (Palm Wine)',
    'Abom (Local Spirit)',
    'Koko (Millet Porridge Drink)',
    'Fura (Millet Yogurt Drink)',
    'Nunu (Local Yogurt)',
    'Atadwe Milk (Tiger Nut Milk)',
    'Coconut Water (Fresh)',
    'Baobab Juice',
    'Tamarind Juice',
    'Ginger Beer (Local)',
    'Herbal Bitters (Alomo, etc.)'
  ];

  const handleCheckboxChange = (beverage: string) => {
    setSelectedBeverages(prev => 
      prev.includes(beverage) 
        ? prev.filter(b => b !== beverage)
        : [...prev, beverage]
    );
  };

  const handleSubmit = () => {
    if (selectedBeverages.length === 0) {
      alert('Please select at least one beverage');
      return;
    }
    
    // Get existing items from localStorage
    const existingItems = localStorage.getItem('selectedOrderItems');
    let allItems: string[] = [];
    
    if (existingItems) {
      try {
        allItems = JSON.parse(existingItems);
      } catch {
        allItems = [];
      }
    }
    
    // Add new selections (avoid duplicates)
    selectedBeverages.forEach(beverage => {
      if (!allItems.includes(beverage)) {
        allItems.push(beverage);
      }
    });
    
    // Save to localStorage
    localStorage.setItem('selectedOrderItems', JSON.stringify(allItems));
    
    // Dispatch custom event to update header count
    window.dispatchEvent(new Event('orderItemsUpdated'));
    
    // Show success message
    const message = document.createElement('div');
    message.className = 'fixed top-24 right-4 bg-green-600 text-white px-6 py-4 rounded-lg shadow-xl z-50 animate-fade-in';
    message.innerHTML = `<i class="ri-check-line mr-2"></i>${selectedBeverages.length} item(s) added to your order`;
    document.body.appendChild(message);
    
    setTimeout(() => {
      message.remove();
    }, 3000);
    
    // Reset selections
    setSelectedBeverages([]);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-black mb-4">
                Local <span className="text-yellow-600">Beverages</span>
              </h1>
              <p className="text-xl text-gray-600">
                Select from our collection of authentic Ghanaian drinks and traditional beverages
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
              <div className="space-y-4 mb-8">
                {beverages.map((beverage, index) => (
                  <label 
                    key={index}
                    className="flex items-center p-4 rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer group"
                  >
                    <input
                      type="checkbox"
                      checked={selectedBeverages.includes(beverage)}
                      onChange={() => handleCheckboxChange(beverage)}
                      className="w-5 h-5 text-yellow-600 border-gray-300 rounded focus:ring-yellow-500 focus:ring-2 cursor-pointer"
                    />
                    <span className="ml-4 text-lg text-gray-800 group-hover:text-yellow-600 transition-colors duration-200">
                      {beverage}
                    </span>
                  </label>
                ))}
              </div>

              <div className="flex justify-end">
                <Button 
                  variant="primary" 
                  size="lg"
                  onClick={handleSubmit}
                >
                  <i className="ri-check-line mr-2"></i>
                  Submit Selection
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
